import UpdateNavBar from './UpdateNavBar';

export default UpdateNavBar;


// WEBPACK FOOTER //
// ./src/components/UpdateNavBar/index.jsx